import { render, staticRenderFns } from "./DeltaChip.vue?vue&type=template&id=2082a3c9"
import script from "./DeltaChip.vue?vue&type=script&lang=js"
export * from "./DeltaChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports